import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import PremiumRoute from "./PremiumRoute";
import AuthenticatedRoute from "./AuthenticatedRoute";

import Home from "@/pages/home";
import LogIn from "@/pages/login";
import ResetPassword from "@/pages/login/ResetPassword";
import PremiumPayment from "@/pages/premiumpayment";
import CaptainsLog from "@/pages/log";
import Layout from "@/components/Common/Layout";
import ViewportMessage from "@/components/Common/ViewportMessage";
import useDisclosure from "@/hooks/useDisclosure";
import { hasShownViewportMessage } from "@/utils/keys";

function PageRoutes() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const showViewportMessage = localStorage.getItem(hasShownViewportMessage) !== "true";

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        onOpen();
      } else {
        onClose();
      }
    };

    const initialCheck = () => {
      if (window.innerWidth < 1024) {
        onOpen();
      }
    };

    window.addEventListener("resize", handleResize);
    initialCheck();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <Layout>
              <Home />
            </Layout>
          }
          path="/premium/:coordsParams?"
        />
        <Route
          element={
            <Layout>
              <Home />
            </Layout>
          }
          path="/poi/:poiId?/:coordsParams?"
        />
        <Route
          element={
            <>
              {isOpen && showViewportMessage && <ViewportMessage onClose={onClose} />}
              <Layout>
                <Home />
              </Layout>
            </>
          }
          path="/:coordsParams?"
        />
        <Route
          element={
            <Layout>
              <Home />
            </Layout>
          }
          path="/promocode/:promocode/:coordsParams?"
        />
        <Route
          element={
            <AuthenticatedRoute>
              <PremiumRoute reverse>
                <Layout>
                  <PremiumPayment />
                </Layout>
              </PremiumRoute>
            </AuthenticatedRoute>
          }
          path="/premium-payment"
        />
        <Route
          element={
            <AuthenticatedRoute>
              <PremiumRoute>
                <Layout>
                  <CaptainsLog />
                </Layout>
              </PremiumRoute>
            </AuthenticatedRoute>
          }
          path="/captains-log"
        />
        <Route element={<LogIn />} path="/login/:id?/:promocode?" />
        <Route element={<ResetPassword />} path="recovery-password" />
      </Routes>
    </BrowserRouter>
  );
}

export default PageRoutes;
